import { Record, Union } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, class_type, union_type, bool_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { AnatomyOrientationProps } from "./AnatomyOrientationBindings.js";

export class LocalMsg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ToggleAnatomyOrientationMarker"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.AnatomyOrientation.Types.LocalMsg", [], LocalMsg, () => [[["Item", bool_type]]]);
}

export class InboundMsg {
    constructor() {
    }
}

export function InboundMsg_$reflection() {
    return class_type("RAWMap.Client.Visualization.AnatomyOrientation.Types.InboundMsg", undefined, InboundMsg);
}

export class OutboundMsg {
    constructor() {
    }
}

export function OutboundMsg_$reflection() {
    return class_type("RAWMap.Client.Visualization.AnatomyOrientation.Types.OutboundMsg", undefined, OutboundMsg);
}

export class ModelAnatomyOrientation extends Record {
    constructor(ShowAnatomyOrientation) {
        super();
        this.ShowAnatomyOrientation = ShowAnatomyOrientation;
    }
}

export function ModelAnatomyOrientation_$reflection() {
    return record_type("RAWMap.Client.Visualization.AnatomyOrientation.Types.ModelAnatomyOrientation", [], ModelAnatomyOrientation, () => [["ShowAnatomyOrientation", bool_type]]);
}

export function ModelAnatomyOrientation_Props_Z550008EC(model) {
    return new AnatomyOrientationProps(model.ShowAnatomyOrientation);
}

